import React from "react";
import { Divider } from "antd";

const MyDivider = ({ marginTop = 6, marginBottom = 24 }) => (
  <Divider style={{ marginTop, marginBottom }} />
);

export default MyDivider;
